<template>
   <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="overflow-x: hidden;overflow-y: auto;width: 100%;height:90%;margin-top: 2%;display: flex;justify-content: center;"
       v-loading="loding">
    <div style="width: 90%;">
      <!-- <div style="text-align: center;">会展服务总结</div> -->
      <div style="margin-top: 2%;">会展名称：{{ServicesData.exhibitionTheme}}</div>
      <div>会展时间：{{ServicesData.exhibitionDate}}</div>
      <div>总结部门：会展服务</div>
      <!-- <div>
        总结内容：本次展会市场趋势情况:{{ServicesData.describe}}
      </div> -->
      <div>
        本次展商共有<span class="span">{{ServicesData.enterpriseCount}}</span>家参展企业签到，<span class="span">{{ServicesData.expertCount}}</span>位专家进行了签到，<span class="span">{{ServicesData.audienceCount}}</span>位观众进行了签到。
        <span class="span">{{ServicesData.arrangedCount}}</span>位专家安排了酒店，<span class="span">{{ServicesData.noArrangedCount}}</span>位专家未安排酒店。
        <span v-for="item in ServicesData.restaurantList"
              :key="item.id">安排了<span class="span">{{Global.RestaurantTypeList.filter(c=>c.id==item)[0]?.name}}</span>。</span>
        安排了<span class="span">{{ServicesData.carTripCount}}</span>车辆进行接送专家,有<span class="span">{{ServicesData.noCarTripCount}}</span>位专家未安排车辆。在展会执行过程中遇到了<span class="span">{{ServicesData.emergenciesCount}}</span>次突发情况。
        开展了<span class="span">{{ServicesData.activityCount}}</span>次活动，其策划的文案为<span class="span">{{ServicesData.copywriting}}</span>。<span v-if="ServicesData.isSurvey">对用户进行了反馈调查。</span>
      </div>
      <div class="drawerDiv">
        <div id="chartSG"
            v-if="true"></div>
      </div>
    </div>
  </div>
</ShowControl>
</template>
  
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {ShowControl},
  data () {
    return {
      caseID: localStorage.getItem("caseId"),
      ServicesData: {},
      ServicesDatas: {},
      loding: false,
      checkSummarize: 0,
      flowID: localStorage.getItem("flowID"),
      title: '会展服务总结'
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  mounted () {
    this.drawSg();
    this.$refs.showControl.receiveValue(true);
  },
  created () {
    //this.GetExhibitionServicesData();
  },
  methods: {
    revertClick(){
      this.$router.push("/ExhibitionServices")
    },
    drawSg () {
      this.loding = true;
      var chartDom = document.getElementById('chartSG');
      var myChart = this.echarts.init(chartDom);
      var option;
      this.$http
        .get(
          "StudentData/GetExhibitionServicesData?round=" +
          this.Round + "&caseID=" + this.caseID
        )
        .then((res) => {
          if (res.success) {
            this.ServicesDatas = res.dynamicObj;
            this.ServicesData = res.dynamicObj.result;
            option = {
              backgroundColor: '#fff',
              // title: {
              //   subtext: '会展营销总结',
              //   left: 'center'
              // },
              // series: [
              //   {
              //     type: 'sankey',
              //     left: 50.0,
              //     top: 20.0,
              //     right: 150.0,
              //     bottom: 25.0,
              //     data: this.ServicesData.data,
              //     links:this.ServicesData.link,
              //     lineStyle: {
              //       color: 'source',
              //       curveness: 0.5
              //     },
              //     itemStyle: {
              //       color: '#1f77b4',
              //       borderColor: '#1f77b4'
              //     },
              //     label: {
              //       color: 'rgba(0,0,0,0.7)',
              //       fontFamily: 'Arial',
              //       fontSize: 10
              //     }
              //   }
              //   ],
              series: [
                {
                  type: 'sankey',
                  data: this.ServicesDatas.data,
                  links: this.ServicesDatas.link,
                  emphasis: {
                    focus: 'adjacency'
                  },
                  lineStyle: {
                    color: 'gradient',
                    curveness: 0.5
                  }
                }
              ],
              tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove'
              }
            };
            option && myChart.setOption(option);
            if (this.flowID == this.Global.FlowList.实验总结) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              if ((that.$store.state.user.checkSummarize & (1 << 3)) == 0) {
                checkSummarize += 8;
                this.checkSummarize = checkSummarize;
                that.$store.commit("checkSummarizecomit", checkSummarize);
              }
            }
            this.loding = false;
            if(this.flowID == 5){
              this.$http
                .get(`StudentData/GetStepOperation?stepID=${this.Global.OperateType.查看会展服务总结}&round=${this.Round}`)
                .then((res) => {
                  if (res.success) {
                    this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看会展服务总结 });  
                  }
                })
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetExhibitionServicesData () {
      this.$http
        .get(
          "StudentData/GetExhibitionServicesData?round=" +
          this.Round + "&caseID=" + this.caseID
        )
        .then((res) => {
          if (res.success) {
            this.ServicesData = res.dynamicObj;
          } else {
            return this.$message.error(res.message);
          }
        });
    },
  },
  watch: {
    checkSummarize (newVal, oldVal) {
      if (newVal == 31) {
        if (this.flowID == this.Global.FlowList.实验总结) {
          this.$http.get(`User/SummarizeScore?round=${this.Round}`).then((res) => {
            if (res.success) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              checkSummarize += 1;
              this.checkSummarize = checkSummarize;
              that.$store.commit("checkSummarizecomit", checkSummarize);
            }
          })
        }
      } else {
        console.log(oldVal)
      }
    }
  }
}
  </script>
  

  <style lang="less" scoped>
.span {
  color: red;
}
.drawerDiv {
  height: 100%;
  display: flex;
  justify-content: center;
}
#chartSG {
  width: 825px;
  height: 600px;
  color: white;
}
</style>